// extracted by mini-css-extract-plugin
export default {"theme":"#ed1c24"};